import React from 'react'

const PreFlightsNumber = ({props}) => {
  return (
    <div className={`w-full mx-auto grid mobileS:grid-cols-1 sm:grid-cols-5 gap-x-6 text-center`}>
      {props?.map(({num, title}) => (
        <div className="flex flex-col justify-stretch items-center">
          <div className="bg-[#d6edd6] text-6xl w-[128px] h-[128px] flex flex-row justify-center items-center rounded-full text-white">
          <p className='text-[#009000]'>
          {num}
          </p>
        </div>
        <p className='text-center'>{title}</p>
        </div>
      ))}
    </div>
  )
}

export default PreFlightsNumber